/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum AssetSortType {
  Popular = "-popularity.month",
  RecentlyAdded = "-created",
  Alphabetical = "localized.sortingTitle",
  Newest = "-productionYear",
  Oldest = "productionYear",
}
